import { useEffect, useState } from "react";
import { Menu, X, MessageCircle } from "lucide-react";
import { BRAND } from "@/lib/brand";

const LINKS = [
  { href: "#solucoes", label: "Soluções" },
  { href: "#nacionalizacao", label: "Nacionalização" },
  { href: "#quem-somos", label: "Quem Somos" },
  { href: "#mercados", label: "Mercados" },
  { href: "#categorias", label: "Categorias" },
  { href: "#contato", label: "Contato" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? "glass-nav shadow-[0_1px_0_rgba(0,0,0,0.04)]" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex items-center justify-between h-28">
          <a
            href="#home"
            data-testid="nav-logo"
            className="flex items-center gap-3 group"
            aria-label="Imporparts — Home"
          >
            <img
              src={BRAND.logoUrl}
              alt="Imporparts"
              className="h-20 w-20 object-contain rounded-md bg-white"
              loading="eager"
            />
            <div className="leading-tight hidden sm:block">
              <div className={`font-display font-bold text-lg ${scrolled ? "text-navy" : "text-white"}`}>
                Imporparts
              </div>
              <div className={`text-[10px] tracking-[0.22em] uppercase font-semibold ${scrolled ? "text-gold" : "text-gold"}`}>
                Soluções Corporativas
              </div>
            </div>
          </a>

          <nav className="hidden lg:flex items-center gap-8">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-link-${l.href.replace("#", "")}`}
                className={`text-sm font-medium tracking-tight transition-colors ${
                  scrolled ? "text-slate-700 hover:text-navy" : "text-white/85 hover:text-white"
                }`}
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <a
              href={BRAND.whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="nav-cta-cotacao"
              className="hidden md:inline-flex items-center gap-2 btn-primary text-sm"
              aria-label="Solicitar cotação via WhatsApp"
            >
              <MessageCircle className="w-4 h-4" />
              Solicitar Cotação
            </a>
            <button
              className={`lg:hidden p-2 rounded-md ${scrolled ? "text-navy" : "text-white"}`}
              onClick={() => setOpen((v) => !v)}
              aria-label="Abrir menu"
              data-testid="nav-mobile-toggle"
            >
              {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>

        {open && (
          <div className="lg:hidden pb-6 pt-2" data-testid="nav-mobile-menu">
            <div className="flex flex-col gap-1 rounded-2xl bg-white/95 backdrop-blur p-4 border border-slate-200 shadow-xl">
              {LINKS.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  data-testid={`nav-mobile-link-${l.href.replace("#", "")}`}
                  className="px-4 py-3 rounded-lg text-slate-800 hover:bg-slate-100 font-medium"
                >
                  {l.label}
                </a>
              ))}
              <a
                href={BRAND.whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="nav-mobile-cta"
                className="mt-2 btn-primary justify-center"
              >
                <MessageCircle className="w-4 h-4" /> Solicitar Cotação
              </a>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};
